import React from 'react';
import { BaseInputProps, Dropdown } from 'ui-builder';
import { SubscriptionEvent } from 'nekst-api';
import { useSubscriptionEventHelper } from './subscriptionEventHelper';

export interface SubscriptionEventDropdownProps extends BaseInputProps {
}

export function SubscriptionEventDropdown(props: SubscriptionEventDropdownProps) {
  const subscriptionEventHelper = useSubscriptionEventHelper();

  return (
    <Dropdown
      options={Object.values(SubscriptionEvent).map(value => ({
        label: subscriptionEventHelper.getLabel(value),
        value: value
      }))}
      {...props}
    />
  );
} 